export enum CustomFieldEntityType {
    Contact = 0,
    ContactIndividual = 1,
    Gift = 2,
}
